

















































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import Analytics from '@/services/Analytics'
import Channel from '@/types/Channel.interface'
import ChannelMultiselectForm from '@/components/ChannelMultiselectForm.vue'
import { ChannelParams, ChannelType } from '@/types/PaginationParams.interface'
import IListTile from '@/types/components/IListTile.interface'
import InboxToolbar from '@/components/InboxToolbar.vue'
import Message from '@/types/Message.interface'
import messageSendMixin from '@/mixins/message-mixin'
import Person from '@/types/Person.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import moment from 'moment-timezone'
import PersonProfile from '@/components/PersonProfile.vue'
import SmsMessagesPanel from '@/components/SmsMessagesPanel.vue'
import MessageTextForm from '@/components/MessageTextForm.vue'
import MessageToForm from '@/components/MessageToForm.vue'
import MultiSelectPanel from '@/components/MultiSelectPanel.vue'
import TypingIndicator from '@/components/TypingIndicator.vue'
import TriPanel from '@/components/TriPanel.vue'
import inboxMixin from '@/mixins/inbox-mixin'
import { GroupBucket } from '@/types/Group.interface'
export default Vue.extend({
    mixins: [inboxMixin, messageSendMixin],
    components: {
        InboxToolbar,
        ChannelMultiselectForm,
        PersonProfile,
        MessageTextForm,
        MessageToForm,
        MultiSelectPanel,
        SmsMessagesPanel,
        TriPanel,
        TypingIndicator
    },
    props: {
        //  The 'view/group_id' id
        groupId: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            //  The IListPlaceholder for the channels list
            channelsListPlaceholder: {
                img: 'noConversations',
                imgStyles: { height: '100%' }
            },
            //  If we are commenting on a specific image, this contains the id
            commentMedia: null,
            //  Determines if we are in comment mode or not
            commentMode: false,
            //  If we are commenting on a specific text, this contains the text we are responding to
            commentObject: null,
            //  Determines if we are currently changing filters for messages
            filterChanged: false,
            //  To store the group name
            groupName: null,
            //  Indicates if the component has been mounted (we use this to make sure $refs exist)
            mounted: false,
            //  The text inserted into the message-text-form
            insert: null,
            //  Is passed to the i-list and renders a show more button in order to let the user manually paginate the list due to loss of scroll 
            showMoreButton: false, 
            //  The toolbar displayed in the tri-panel
            toolbar: {
                title: 'Inbox',
                help: {
                    title: 'Manage 1-on-1 Conversations as a Team',
                    body: "Communication gets easier when it lives in one place. Unify your entire team's text message conversations into one shared inbox with MessageDesk.",
                    embedded: `<div class="mx-4" style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/7d843d286dd64f55a84155f4dbf09104" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>`,
                    button: {
                        text: 'Learn More',
                        link: `${process.env.VUE_APP_URL_LEARN}/en/articles/6098181-messaging-as-a-team`
                    }
                },
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/home',
                        tooltip: 'Back',
                        permission: 0
                    }
                ]
            }
        }
    },
    beforeDestroy() {
        //  When leaving the inbox, unset everything (the channel watcher will unset the rest)
        this.unsetChannel()
    },
    beforeRouteLeave(to, from, next) {
        //  If we are going to a non-bucket route, then unset our bucket
        const isBucket = to.fullPath.includes('/i/g')

        //  If it is NOT a bucket, then unset our bucket
        if (!isBucket) this.$store.commit('inboxSelectedBucketSet', null)

        //  Check if changes have been made to the Person
        this.interuptNavigation(next)
    },
    async mounted() {
        //  If a groupId is set
        if (this.groupId) {
            //  Set the groupId on the channels paginate params
            this.channelsParams.bucket = this.groupId

            //  Get the group
            const group = await this.$store.dispatch('groupsFind', parseInt(this.groupId))

            //  Set our bucket to this group
            this.$store.commit('inboxSelectedBucketSet', group)

            //  Set the group name
            this.groupName = group.name
        }

        //  Check if a channel is set in the url params
        const id = this.$route.query.channel

        //  If a channel id exists, load it
        if (id) this.$store.dispatch('inboxSelectedChannelGet', id)

        //  Check if we have an assigned query param
        const assigned = this.$route.query.assigned

        //  If we do, change our filter to match this id
        if (assigned) {
            //  Grab our current params
            const curr = this.channelsParams

            //  Tell our filter applied function about this with the new assigned
            //  Do it this way to avoid cloning + avoid referencing
            this.onFilterApplied({ ...curr, assigned: parseInt(assigned) })

            //  Lets remove the query param now that it is used to prevent this from repeating
            this.$router.replace({ assigned: {} })
        }

        //  We use this mounted variable to track when dom elements have been rendered
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            channels: 'inboxChannels',
            channelsParams: 'inboxChannelsParams',
            channelsPaginating: 'inboxPaginating',
            drafts: 'messageDrafts',
            filteredMessagesPaginating: 'inboxSelectedFilteredMessagesPaginating',
            filteredMessagesParams: 'inboxSelectedFilteredMessagesParams',
            lastChannelsPage: 'inboxChannelsLastPage',
            lastFilteredMessagePage: 'inboxSelectedFilteredMessagesLastPage',
            lastMessagePage: 'inboxSelectedMessagesLastPage',
            messagesPaginating: 'inboxSelectedMessagesPaginating',
            messagesParams: 'inboxSelectedMessagesParams',
            scrollPositionLeft: 'scrollPositionLeft',
            scrollPositionCenter: 'scrollPositionCenter',
            selectedBucket: 'inboxSelectedBucket',
            signature: 'signature',
            users: 'users'
        }),
        //  The IList that is hosting the currently loaded channels
        channelsIList() {
            return this.$store.getters.iList('inboxChannelsList')
        },
        //  Indicates if the InboxFilter has been modified from its default state
        filterModified() {
            //  Get the default pagination params
            const defaults = this.$store.getters.inboxChannelsParamsDefault

            //  Get the current pagination params
            const params = this.$store.getters.inboxChannelsParams

            //  Determine if the filter has been modified
            const isModified =
                defaults.assigned != params.assigned ||
                defaults.status != params.status ||
                defaults.order_by != params.order_by

            //  Return the result
            return isModified
        },
        //  Determine if the selected message tread has more pages
        hasMore() {
            //  Grab our current message type
            const type = this.messageType

            //  We are filtered if type is NOT equal to 'channel'
            const filtered = type !== 'channel'

            //  If we are filtered, use the filtered params
            if (filtered) {
                return (
                    this.filteredMessagesParams.page < this.lastFilteredMessagePage &&
                    this.filteredMessagesPaginating
                )
            }
            //  Else, we have a value of 'channel' then we depend on default message params
            else {
                return (
                    this.messagesParams.page < this.lastMessagePage &&
                    this.messagesPaginating
                )
            }
        },
        //  Return an array of multi-selected channelIds
        multiSelectedChannelIds(): number[] {
            //  If the channelsIList does NOT exist, return empty array
            if (!this.channelsIList) return []

            //  Assemble an array of multi-selected channel ids
            const ids = this.channelsIList.multiSelected.map(
                (channel: Channel) => channel.id
            )

            //  Return the channel ids
            return ids
        },
        //  The type of messages we are displaying
        messageType: {
            get(): string {
                return this.$store.getters.inboxMessageType
            },
            set(type: string): void {
                this.$store.commit('inboxMessageTypeSet', type)
            }
        },
        //  The v-model for our Open/Closed filter toggle
        open: {
            get(): boolean {
                return this.$store.getters.inboxOpen
            },
            set(bool: boolean) {
                this.$store.commit('inboxOpenSet', bool)
            }
        }, 
        //  The currently selected channel
        selectedChannel: {
            get(): Channel {
                return this.$store.getters.inboxSelectedChannel
            },
            set(channel: Channel) {
                this.$store.commit('inboxSelectedChannelSet', channel)
            }
        },
        //  The filtered messages for the currently seelcted channel
        selectedFilteredMessages: {
            get(): Message[] {
                return this.$store.getters.inboxSelectedFilteredMessages
            },
            set(messages: Message[] | null) {
                this.$store.commit('inboxSelectedFilteredMessagesSet', messages)
            }
        },
        //  The messages of the currently selected channel
        selectedMessages: {
            get(): Message[] {
                return this.$store.getters.inboxSelectedMessages
            },
            set(messages: Message[]) {
                this.$store.commit('inboxSelectedMessagesSet', messages)
            }
        },
        //  The contact bound to the currently selected channel
        selectedPerson: {
            get(): Person {
                return this.$store.getters.inboxSelectedPerson
            },
            set(person: Person) {
                this.$store.commit('inboxSelectedPersonSet', person)
            }
        }
    },
    methods: {
        //  This event listener is triggered when a message or comment is sent from the message-text-form component, we only re-append the message signature if the message type is not a comment.
        //  The insertSignature() already has logic to ensure that the message signature setting is enabled before re-adding the signature to the compose box so we don't check that here
        addSignatureOnSend(): void {
            if (!this.commentMode) this.insertSignature()
        },
        //  The channels tile bound to the channels list
        channelTile(): IListTile {
            //  Get the filters attached to the Vue instance
            const f = this.$options.filters

            return {
                actionHeader: (channel: Channel) => f.channelStatus(channel),
                actionContent: (channel: Channel) => this.channelAction(channel),
                actionFooter: (channel: Channel) => f.channelWaiting(channel),
                line1: (channel: Channel) => f.channelName(channel),
                line2: (channel: Channel) => f.channelLastMsgTxt(channel),
                line3: (channel: Channel) => f.channelAssigned(channel),
                callback: (channel: Channel) => this.onChannelSelected(channel)
            }
        },
        //  Creates object to send IListTile the inbox-status-switch component for hover effect
        inboxHover() {
            const hover = {
                component: 'inbox-status-switch',
                props: {
                    open: this.open
                },
                events: {
                    onChange: (item: Channel, itemId: Number) => {
                        this.toggleOpenClosedHandler(item, itemId)
                    }
                }
            }
            return hover
        },
        //  Insert a draft into the MessageText form
        insertDraft(channel: Channel): void {
            //  Check if a draft exists for the channel
            const draft = this.drafts.find((x) => x.channel_id == channel.id)

            //  If a draft does NOT exist, set form to empty text
            if (!draft) return this.$refs.messageForm.insertDraft({ text: '' })

            //  Else, insert the draft into the message text form
            this.$refs.messageForm.insertDraft(draft)
        },
        //  Insert a signature into the MessageText form
        insertSignature() {
            //  Check if our signature is enabled
            const enabled = this.signature.enabled

            //  If our signature is NOT enabled, we are done
            if (!enabled) return

            //  If our signature is enabled, then our text will include it
            const sig = this.signature.data

            //  Check if the message text form already contains the signature
            const included = this.$refs.messageForm.text.includes(sig)

            //  If the message text form already contains it, we are done
            if (included) return

            //  Else, we have to append this
            this.$refs.messageForm.text += sig

            //  Autofocus after the next tick
            this.$nextTick(() => {
                this.$refs.messageForm.autoFocus(true)
            })
        },
        interuptNavigation(callback: Function) {
            //  Check if the currently loaded person has been changed (ie needs to be saved)
            const save = this.$refs.personsProfile && this.$refs.personsProfile.edited

            //  If we do NOT need to save changes, continue
            if (!save) return callback()

            //  Else, pop the confirm changes dialog
            this.$refs.personsProfile.confirmChanges(callback)
        },
        //  Update multi-selected channels as open or closed (depending on 'open' toggle)
        async markChannelsOpenClosed(hotKeyPressed: boolean = false) {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) {
                return
            }

            //  Grab all of our channels
            const channels = this.channelsIList.multiSelected

            //  Get the current moment UTC datetime
            const now = moment.utc().format('YYYY-MM-DD HH:mm:ss')

            //  Our values depend on whether we are opening or closing
            let values = {}

            //  If we are currently open, we want to close everything
            if (this.open) values = { open: null, closed: now }
            //  Else, do the opposite
            else values = { open: now, closed: null }

            //  Container for our payload
            const payload = {
                channel_ids: this.multiSelectedChannelIds,
                values: values
            }

            //  Send the changes to the server
            await this.$store.dispatch('channelsPutBatch', payload)

            // Reset our selected tile when we close a channel as we are sending it to a different IList
            this.$refs.channelsList.selectedTile = null

            //  Deselect multiselected items
            this.$refs.channelsList.multiSelectReset()

            //  If channels were open, track with Analytics
            if (this.open) Analytics.onMultiChannelsClosed(channels)
        },
        //  Call the ChannelAssignmentForm function markAsNew so that our shortcut marks a conversation as new
        async markNew(): Promise<void> {
            if (!this.hotKeysEnabled.enabled) {
                return
            }

            // If we don't have a tile selected, don't let the user use markNew
            if (!this.$refs.channelsList.selectedTile) {
                return
            }

            // If we are using multiselect, we use the  assignment form version of marking something as new
            if (this.channelsIList.multiSelected.length) {
                // Call channel assignment form function that enables us to mark a conversation as new in multiselect
                this.$refs.channelAssignmentForm.markAsNew()

                // Calls the Ilist navigation function to reset where our selecion is so that user can still use arrow keys
                this.$refs.channelsList.navigation()

                return
            }

            // Create channel_ids array that contains our single selected channel
            const channel_id = [this.$refs.channelsList.selectedTile.id]

            //  Additional props for our payload
            const additional = {
                unread_messages: 1,
                closed: null,
                open: moment.utc().format('YYYY-MM-DD HH:mm:ss')
            }

            // Construct payload to send to api
            const payload = {
                channel_ids: channel_id,
                values: additional
            }

            //  Send our API request
            await this.$store.dispatch('channelsPutBatch', payload)

            // Calls the Ilist navigation function to reset where our selecion is so that user can still use arrow keys
            this.$refs.channelsList.navigation()

            //  Publish the process completed event (this will reset the multi-selected items in iList, and reset the inbox filter)
            this.$emit('processCompleted')
        },
        //  Handler for selecting a message channel in the ilist
        onChannelSelected(channel: Channel) {
            //  Check if the channel is different from the currently selected channel
            const isNew = !this.selectedChannel || channel.id != this.selectedChannel.id

            //  The 'next' function contains all the stuff we need to do when a channel is selected. (we define the handler so we can pass it to other components as a callback)
            const next = () => {
                //  Navigate to step 2 of the mobile interface
                this.$refs.inboxTriPanel.setStep(2)

                //  If the channel is NOT different from the current channel, do nothing else
                if (!isNew) return

                //  Set the selected channel
                this.selectedChannel = channel

                //  clone the current query params (we do this to avoid the Vue duplicate naviagtion error)
                const query = Object.assign({}, this.$route.query)

                //  Update the channel query param (there is watcher on this value that handles fetching the messages & person)
                query.channel = channel.id

                //  Update the current url
                this.$router.push({ query })
            }

            //  If this is a new channel, we need to check for person changes before continuing
            if (isNew) return this.interuptNavigation(next)

            //  Else, just navigate to step 2 of the mobile interface
            this.$refs.inboxTriPanel.setStep(2)
        },
        //  Handle the filterApplied event coming from InboxFilter
        onFilterApplied(params: ChannelParams): void {
            //  Close the filter dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Check if the applied filter is the same as the current filter
            const isSame = window._.isEqual(this.channelsParams, params)

            //  If the filter is the same as the current list, do nothing
            if (isSame) return

            //  Also unset our id in the query
            if (this.$route.query.channel) this.unsetChannel()

            //  Set cursor to null since we changed our filter
            params.id = null
            params.lastMessageTime = null

            //  Update the params in the store
            this.$store.commit('inboxChannelsParamsSet', params)

            //  The filter has changed, so paginate the new filter
            this.$store.dispatch('inboxChannelsPaginate')
        },
        //  Handles missing messages from websocket breaks (NOTE: might not work 100% of the time with schedules)
        onMessagesLoaded(messages: Message[]): void {
            //  Get our channel
            const channel = this.selectedChannel

            //  Grab the last message for this channel
            const lastMsg = channel.last_message

            //  If the channel has no last message, we are done
            if (!lastMsg) return

            //  Grab our last message
            const lastLoad = messages[messages.length - 1]

            //  Check if our query id is greater than our last id
            const needLoad = lastMsg.id > lastLoad.id

            //  Grab our channel query
            const channelId = this.$route.query.channel

            //  Grab our message query
            const messageId = this.$route.query.message

            //  If it is, then we need to get our messages
            if (needLoad) {
                //  Clear our message cache for this channel
                this.$store.commit('messagesCacheRemove', channelId)

                //  Paginate our messages
                this.$store.dispatch('inboxSelectedMessagesPaginate', channelId)
            }

            //  Remove our message id from our query params if we have it
            if (messageId) this.$router.replace(`/inbox?channel=${channelId}`)
        },
        //  Handle the personSelected event coming our MessageToForm
        onPersonSelected(person: Person) {
            //  If person is null, do nothing
            if (!person) return

            //  Else, route to channel
            this.$store.dispatch('inboxSelectedChannelGet', person.primary_channel_id)
        },
        //  Handle the 'Open/Close' toggle event
        onTypeChange(type: ChannelType): void {
            //  Toggle our open
            this.open = type === 'open' ? true : false

            //  Get current channels filter
            const params = this.channelsParams

            //  Check if the input constitutes a change to the current params
            const isSame = params.type === type

            //  If the input is the same as the current filter, do nothing
            if (isSame) return

            //  Also unset our id in the query
            if (this.$route.query.channel) this.unsetChannel()

            // Reset our selected tile when we change between open/closed since we are accessing a different Ilist
            this.$refs.channelsList.selectedTile = null

            //  Else, set the channel type on the params
            params.type = type

            //  Set cursor to null since we changed our filter
            params.id = null
            params.lastMessageTime = null

            //  Update the store
            this.$store.commit('inboxChannelsParamsSet', params)

            //  Paginate the changes
            this.$store.dispatch('inboxChannelsPaginate')
        },
        //  Handles the animation for the IList Hover open/close conversation
        openCloseAnimation(hoverItem: Channel, itemId: Number): void {
            //  grab the hovered channel
            const channel = hoverItem

            //  Get the channels current 'open' state
            const isOpen = this.$options.filters.channelOpen(channel)

            //  Create our selector for use in IListTile
            const selector = `i-list-tile-${itemId}`

            //  Grab the specific tile to add/remove animations
            const element = document.getElementById(selector)

            //  If we can't find the element exit function before animations apply
            if (!element) return

            //  We apply different animations depending on current open/closed state
            if (isOpen) {
                element.classList.add('closeAnimation')
                setTimeout(() => {
                    element.classList.remove('closeAnimation')
                }, 500)
            } else {
                element.classList.add('openAnimation')
                setTimeout(() => {
                    element.classList.remove('openAnimation')
                }, 500)
            }
        },
        //  Pop the InboxFilter dialog
        openFilterOptions(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Sort and Filter',
                titleStyles: {
                    'text-align': 'center',
                    background: '#6142B0',
                    color: 'white',
                    padding: '16px 24px 10px !important'
                },
                height: '600px !important',
                noTitleGutter: true,
                component: 'inbox-filter',
                closeable: true,
                btnColor: 'white',
                callback: (payload) => this.onFilterApplied(payload)
            })
        },
        //  Paginate the next page of the current filtered list
        paginateChannelList(): void {
            //  Get current pagination params
            const params = this.channelsParams            
            
            //  We attempt to grab the last channel within our channels list, this is okay as slice will just return null if the list is empty
            const currentLastChannel = this.channels.slice(-1)

            //  We just want to return if we have no items in our list to paginate 
            if (!currentLastChannel) return

            //  If we do have a last item in our list we need to grab the last_message_time and id properties so we can properly sort and paginate our list. These two items
            //  are neccassary for our cursor pagination. We have to encode the last_message_time since it has special characters and we pass these params as query params to our api.
            params.lastMessageTime = encodeURIComponent(currentLastChannel[0].last_message_time)
            params.id = currentLastChannel[0].id

            //  Else, update pagination params
            this.$store.commit('inboxChannelsParamsSet', params)

            //  Paginate the next page
            this.$store.dispatch('inboxChannelsPaginate')
        },
        //  Paginate filtered messages. Handles paginate scroll event (ie, paginates page > 1)
        async paginateFilteredMessagesList(): Promise<void> {
            //  Grab our current channel
            const channel = this.selectedChannel

            //  If no channel, return
            if (!channel) return

            //  Else, grab our channel id
            const id = channel.id

            //  Get current pagination params
            const params = this.filteredMessagesParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine if we should paginate
            const shouldPaginate = nextPage <= this.lastFilteredMessagePage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Grab our current type
            const type = this.messageType

            //  Else, update our pagination params
            params.page = nextPage
            params.filters = [type]
            this.$store.commit('inboxSelectedFilteredMessagesParamsSet', params)

            //  Paginate the next page
            await this.$store.dispatch('inboxSelectedFilteredMessagesPaginate', id)

            //  Scroll to the last position
            this.$refs['inboxTriPanel'].scrollTo(this.scrollPositionCenter)
        },
        //  Paginate selected messages. Handles paginate scroll event (ie, paginates page > 1)
        async paginateMessageList(paginateFromSearch: boolean = false): Promise<void> {
            //  Grab our current channel
            const channel = this.selectedChannel

            //  If no channel, return
            if (!channel) return

            //  Else, grab our channel id
            const id = channel.id

            //  Get current pagination params
            const params = this.messagesParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine if we should paginate
            const shouldPaginate = nextPage <= this.lastMessagePage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update our pagination params
            params.page = nextPage
            this.$store.commit('inboxSelectedMessagesParamsSet', params)

            //  Paginate the next page
            await this.$store.dispatch('inboxSelectedMessagesPaginate', id)

            //  If this function was called from SmsMessagesPanel.vue then we want to recursivly call the scrollToItem() function to try and scroll to the newly paginated messages
            if (paginateFromSearch) this.$refs.smsMessagesPanel.scrollToItem()
            
            //  Scroll to the last position
            else this.$refs['inboxTriPanel'].scrollTo(this.scrollPositionCenter)
        },
        //  Save a draft to the vuex store
        setDraft(text: string): void {
            //  Grab our channel query
            const id = this.$route.query.channel

            //  If there is no channel query do NOT save a draft
            if (!id) return

            //  Grab our signature text
            const sig = this.signature.data

            //  Strip it from our text
            const stripped = text.replace(sig, '')

            //  else, save this draft
            this.$store.commit('messageDraftSet', {
                channel_id: id,
                text: stripped
            })
        },
        //  Toggle the conversation as open/close
        toggleOpenClosed(hoverItem: Channel, hotKeyPressed: boolean): void {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) {
                return
            }

            //  If our hotkeys are active and used with no selected channel, leave
            if (hotKeyPressedAndOn && this.selectedChannel === null) {
                //  Just considering this as information for ease of use
                const title = 'Error: No Channel Selected for open or close'
                const description = 'Please select the channel you want to open or close'
                this.$store.commit('notificationPopupOpen', {
                    title: title,
                    text: description,
                    icon: 'bi-question-circle-fill',
                    closeable: true,
                    type: 'fail'
                })

                return
            }

            // Grab our selected, highlighted or hovered channel and use that to mark as closed or open\
            const channel = hoverItem || this.$refs.channelsList.selectedTile

            //  Get the channels current 'open' state
            const isOpen = this.$options.filters.channelOpen(channel)

            //  If the channel isOpen, close it
            if (isOpen) {
                channel.closed = true
                channel.open = null

                //  Report to analytics
                Analytics.track('ConversationCloseToggled')
            }
            //  Else, open it
            else {
                channel.open = true
                channel.archived = false
                channel.closed = null
            }

            //  If we want to close a channel that is open we should remove it from view
            if (channel.id === this.selectedChannel?.id) {
                //  Unset our channel
                this.unsetChannel()

                //  Go to step 1
                this.$refs.inboxTriPanel.step = 1
            }

            //  Push changes to the server
            this.$store.dispatch('channelsPut', channel)
        },
        toggleOpenClosedHandler(item: Channel, itemId: Number): void {
            //  Starts the animation to open/close conversation
            this.openCloseAnimation(item, itemId),
                //  API call and other open/close logic
                //  delayed so the replacing tile doesn't populate during animation
                this.toggleOpenClosed(item, null)
        },
        //  Reset the inbox's selected items
        unsetChannel(hotKeyPressed: boolean = false): void {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) return

            //  Unset our channel
            this.selectedChannel = null

            //  Unset our filtered messages
            this.selectedFilteredMessages = []

            //  Unset our messages
            this.selectedMessages = []

            //  Unset our person
            this.selectedPerson = null

            //  Turn comment mode off
            this.commentMode = false

            //  Remove our comment response
            this.commentResponse = null

            //  Make sure our comment response is null
            this.commentObject = null

            //  Make sure our comment media is also null
            this.commentMedia = null

            //  Reset our send type
            this.messageType = 'channel'

            //  Grab our current path
            const path = this.$route.path

            //  If the path is NOT inbox we are done
            if (!path.includes('inbox')) return

            //  Reset the message text form
            this.$refs.messageForm.reset()

            //  If our query does not have a channel, we set the tripanel to step 1 so that the user can see all their channels 
            if (!this.$route.query.channel) return  this.$refs.inboxTriPanel.setStep(1)

            //  Remove the channel query params from the route
            this.$router.replace({ channel: {} }) 
        }
    },
    watch: {
        //  We watch how the i-list channels are being moved, depending on certain conditions we either automatically paginate for the customer or we show the 'show more button' which enables
        //  the user to manually paginate themselves, this is because our scrollbar disappears when the conversation list is less than the overall screen height and thus they cannot paginate
        //  by scroll and would have to refresh to paginate the list again. 
        channels() {  
            //  When a user can no longer scroll the bottom and top positions of the scrollbar will be false since it doesn't exist 
            const isScrollable = this.scrollPositionLeft.bottom && this.scrollPositionLeft.top

            //  We check if there are more items to paginate. We know there are more items to paginate and that the user might be in a potential no scroll use case when they have less than 
            //  our pagination limit left in the list and the api tells us we have more channels not yet paginated.
            const isPaginatable = this.channels.length < this.channelsParams.limit && this.channelsParams.hasMoreChannels

            //  We need this check since users can multiselect and close/open the entire list at once. This edgecase causes our button to not appear thus not letting the user paginate so if we have 
            //  0 items in the list we know they closed or opened all channels currently rendered and that we might need to paginate for them. 
            const isCurrentlyEmpty  = this.channels.length === 0

            //  If we have more items available to render and our list is currently empty then we manually paginate the channel list for the user, due to the performace improvements of cursor pagination
            //  this is barely noticable 
            if (isPaginatable && isCurrentlyEmpty) {
                //  Grab our params so we can change them
                let params = this.channelsParams
                
                //  Set cursor to null since we are restarting our pagination 
                params.id = null
                params.lastMessageTime = null

                //  Update the params in the store
                this.$store.commit('inboxChannelsParamsSet', params)

                //  Directly call pagination for the user
                return this.$store.dispatch('inboxChannelsPaginate')
            }

            //  If we have determined that the user cannot scroll, they have more items to paginate, and that they still have items within their list, then we give them the show more button 
            //  which will manually activate pagination when a user presses it. 
            this.showMoreButton = !isScrollable && isPaginatable
        },  
        //  We watch if the user changes from the comment mode to typical message send mode, if they do we reappend the message signature if enabled, reason being that we reset the message-text-form component when changing from comment
        //  to message send mode so we need to re-add the text otherwise the message signature is not appended in this edge case
        commentMode() {
            if (!this.signature.enabled) return 

            this.insertSignature()
        },  
        //  Watch the groupId prop, if set, change the channel pagination params, else remove from params
        async groupId(val): Promise<void> {
            //  Deselect multiselected items
            this.$refs.channelsList.multiSelectReset()

            //  Parse the group id into an int
            const id = parseInt(this.groupId)

            //  If we don't have a group id then set group name to null
            if (!id) {
                //  Set our bucket group to null
                this.$store.commit('inboxSelectedBucketSet', null)

                //  Update our group name to be null
                this.groupName = null
            }
            //  `Else we need to find the group
            else {
                //  Get our group
                const group = await this.$store.dispatch('groupsFind', id)

                //  Set our bucket group
                this.$store.commit('inboxSelectedBucketSet', group)

                //  Change the group name
                this.groupName = group.name
            }

            //  Get the current pagination params
            const params = window._.cloneDeep(this.channelsParams)

            //  Reset params to page 1, since we will be paginating a new list
            params.page = 1

            //  Our bucket param will be equal to the value of our id
            params.bucket = val || null

            //  Check if the params are the same as the current list
            const isSame = window._.isEqual(params, this.channelsParams)

            //  If the params are the same, no need to paginate, so do nothing
            if (isSame) return

            //  Set page to 1 since we changed our filter
            params.page = 1

            //  Update the params in the store
            this.$store.commit('inboxChannelsParamsSet', params)

            //  Paginate the new channels list
            this.$store.dispatch('inboxChannelsPaginate')
        },
        // Watch for changes to 'channel' query parameter
        $route(to, from) {
            //  If we were removing the assigned param, do nothing
            if (!to.query.assigned && from.query.assigned) return

            //  If the 'channel' query param does NOT exist, unset our selected data
            if (!to.query.channel) return this.unsetChannel()

            //  Check if we have a new message query
            const newMsg = to.query.newMessage

            //  If it exists, then just move to step 2 and that's it
            if (newMsg) return (this.$refs.inboxTriPanel.step = 2)

            //  Else, get the channel id from the query param
            const id = to.query.channel

            //  Grab a message query
            const msgId = to.query.message

            //  Check if 'channel' param is different from the currently loaded channel
            const needsLoad =
                !this.selectedChannel || id != this.selectedChannel.id || msgId

            //  If a channel does NOT need to be loaded, do nothing
            if (!needsLoad) return

            //  We need to load the channel so move
            this.$refs.inboxTriPanel.step = 2

            //  Else, fetch the new channel
            this.$store.dispatch('inboxSelectedChannelGet', id)
        },
        async messageType(val: string, prev: string): Promise<void> {
            //  If our previous and current are the same, do nothing
            if (prev === val) return

            //  Grab our current channel
            const channel = this.selectedChannel

            //  If it doesn't exist, do nothing
            if (!channel) return

            //  Else grab the channel id
            const id = channel.id

            //  Grab our params
            const params = this.filteredMessagesParams

            //  Set our page to 1
            params.page = 1

            //  Use our filter
            params.filters = [val]

            //  Tell our messages panel to start loading
            this.filterChanged = true

            //  Set our params
            this.$store.commit('inboxSelectedFilteredMessagesParamsSet', params)

            //  Paginate the next page
            await this.$store.dispatch('inboxSelectedFilteredMessagesPaginate', id)

            //  Tell our messages panel we stopped loading
            this.filterChanged = false
        },
        selectedBucket(bucket: GroupBucket) {
            //  If our bucket changed, do nothing because our groupId watcher does it
            if (bucket) return

            //  If we are already at the inbox then do nothing
            if (this.$route.path.includes('inbox')) return

            //  Else, navigate back to inbox
            this.$router.push('/inbox')
        },
        selectedChannel(channel: Channel | null, prev: Channel | null) {
            //  If the channel was set to null, we need to remove the selected messages, person, and drafts
            if (!channel) return this.unsetChannel()

            //  Grab our message query
            const msgId = this.$route.query.message

            //  IF the channel didn't change AND we don't have a message query, do nothing
            if (channel.id === prev?.id && !msgId) return

            //  Else, the channel is new so we should reset the person and messages
            // this.selectedPerson = null
            this.selectedMessages = []

            //  Set our filter back to 'channel'
            this.messageType = 'channel'

            //  Update the read status on this channel IF it needs it
            if (channel.unread_messages > 0) {
                this.$store.dispatch('channelsPut', { ...channel, unread_messages: 0 })
            }

            //  Else, we need to fetch the channel's person profile
            this.$store.dispatch('inboxSelectedPersonGet', channel)

            //  Our channel changed so make sure we reset the params on our scheduled and selected messages
            this.$store.commit('inboxSelectedMessagesParamsReset')

            //  The selected channel has changed, we need to update the SmsPanel
            this.$store
                .dispatch('inboxSelectedMessagesPaginate', channel.id)
                .then(this.onMessagesLoaded)

            //  If we are in comments mode, clear our text
            if (this.commentMode) this.resetComments()
            //  Else, insert our draft and sig
            else {
                //  The selected channel has loaded, we need to insert drafts if available
                this.insertDraft(channel)

                //  Insert signature if needed
                this.insertSignature()
            }
        },
        scrollPositionLeft(position: ScrollPosition): void { 
            //  If we are NOT paginating channels AND scroll is at bottom, paginate next page
            if (!this.channelsPaginating && position.bottom) this.paginateChannelList()
        },
        scrollPositionCenter(position: ScrollPosition): void {
            //  If we are not at top, do nothing
            if (!position.top) return

            //  Grab our current message type
            const type = this.messageType

            //  Check if we are filtered
            const filtered = type !== 'channel'

            //  Our paginating tracker is based on if we are filtered
            const paginating = filtered
                ? this.filteredMessagesPaginating
                : this.messagesPaginating

            //  If we are paginating, do nothing
            if (paginating) return

            //  Else, paginate based on filter
            if (filtered) this.paginateFilteredMessagesList()
            else this.paginateMessageList()
        }
    }
})
